import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { merchantActiveBanks } from "../api/aepsApi";
import { setAepsBanks, setAepsPipe } from "../features/aepsSlice";

export const useAepsBank = () => {
  const dispatch = useDispatch();
  const { pipe, banks } = useSelector((s) => s.aeps);

  useEffect(() => {
    const load = async () => {
      const res = await merchantActiveBanks();
      if (!res.success) return;

      dispatch(setAepsBanks(res.banks));

      const defaultBank =
        Object.keys(res.banks).find((b) => res.banks[b] === 1) || "bank1";

      dispatch(setAepsPipe(defaultBank));
    };

    if (!pipe) load();
  }, [pipe, dispatch]);

  const changeBank = (bank) => {
    dispatch(setAepsPipe(bank));
  };

  return { banks, selectedBank: pipe, changeBank };
};
